/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: bun run autoexport.
//

import type { RasterResult, RasterizeOptions, SeparationOptions, SeparationResult } from "../types/Types"
import type { Float, Result } from "@pdfking/tfunc"
import { UInt8ToString } from "@pdfking/tfunc"
import type { WasmInstance } from "@pdfking/wasm-core"
import { DefaultMinimap as E } from "@pdfking/wasm-core"
const enum F {
    create_separation = "$4",
    rasterize_page = "$d"
}
type CallReturn = {
    [E.malloc]: number | bigint
    [E.free]: void
    [F.create_separation]: bigint
    [F.rasterize_page]: bigint
}
const mem = (i: WasmInstance) => (i.exports[E.memory] as WebAssembly.Memory).buffer
const u32_b = (v: number) => new Uint8Array(new Uint32Array([v]).buffer)
const f64_b = (v: number) => { const b = new Uint8Array(8); new DataView(b.buffer).setFloat64(0, v, true); return b; }
const pa = (i: WasmInstance, v: number): number | bigint => i.memory64 ? BigInt(v) : v
const call = <K extends keyof CallReturn>(i: WasmInstance, name: K, ...args: (number | bigint)[]): CallReturn[K] => (i.exports[name] as (...a: (number | bigint)[]) => CallReturn[K])(...args)
const write_args = (i: WasmInstance, ...chunks: Uint8Array[]): [
    number,
    number
] => {
    const total = chunks.reduce((s, c) => s + c.length, 0)
    const base = Number(call(i, E.malloc, pa(i, total)))
    const heap = new Uint8Array(mem(i))
    let off = base
    for (const c of chunks) {
        heap.set(c, off)
        off += c.length
    }
    return [base, total]
}
const write_buf = (i: WasmInstance, data: Uint8Array): [
    number,
    number
] => {
    const ptr = Number(call(i, E.malloc, pa(i, data.length)))
    new Uint8Array(mem(i)).set(data, ptr)
    return [ptr, data.length]
}
const call_with = (i: WasmInstance, fn: F, ...chunks: Uint8Array[]): [
    number,
    number
] => {
    const [base, total] = write_args(i, ...chunks)
    const ret = call(i, fn, pa(i, base), total) as bigint
    call(i, E.free, pa(i, base), pa(i, total))
    return [Number(ret & 0xffffffffn), Number(ret >> 32n)]
}
const Cursor = (i: WasmInstance, p: number) => {
    const buf = mem(i)
    const dv = new DataView(buf)
    const u8 = new Uint8Array(buf)
    let pos = p
    const i8 = () => { const v = dv.getInt8(pos); pos += 1; return BigInt(v); }
    const u8r = () => { const v = dv.getUint8(pos); pos += 1; return BigInt(v); }
    const i16 = () => { const v = dv.getInt16(pos, true); pos += 2; return BigInt(v); }
    const u16 = () => { const v = dv.getUint16(pos, true); pos += 2; return BigInt(v); }
    const i32 = () => { const v = dv.getInt32(pos, true); pos += 4; return BigInt(v); }
    const u32 = () => { const v = dv.getUint32(pos, true); pos += 4; return v; }
    const f32 = () => { const v = dv.getFloat32(pos, true); pos += 4; return v; }
    const f64 = () => { const v = dv.getFloat64(pos, true); pos += 8; return v; }
    const i64 = () => { const v = dv.getBigInt64(pos, true); pos += 8; return v; }
    const u64 = () => { const v = dv.getBigUint64(pos, true); pos += 8; return v; }
    const i128 = () => { const lo = dv.getBigUint64(pos, true); const hi = dv.getBigInt64(pos + 8, true); pos += 16; return (hi << 64n) | lo; }
    const u128 = () => { const lo = dv.getBigUint64(pos, true); const hi = dv.getBigUint64(pos + 8, true); pos += 16; return (hi << 64n) | lo; }
    const i256 = () => { let v = 0n; for (let j = 0; j < 4; j++) {
        v |= dv.getBigUint64(pos + j * 8, true) << BigInt(j * 64)
    } pos += 32; return v >= (1n << 255n) ? v - (1n << 256n) : v; }
    const u256 = () => { let v = 0n; for (let j = 0; j < 4; j++) {
        v |= dv.getBigUint64(pos + j * 8, true) << BigInt(j * 64)
    } pos += 32; return v; }
    const bool = () => !!u32()
    const str = () => {
        const ptr = u32()
        const len = u32()
        const s = UInt8ToString(u8.subarray(ptr, ptr + len))
        call(i, E.free, pa(i, ptr), pa(i, len))
        return s
    }
    const bytes = () => {
        const ptr = u32()
        const len = u32()
        const d = u8.slice(ptr, ptr + len)
        call(i, E.free, pa(i, ptr), pa(i, len))
        return d
    }
    return { i8, u8: u8r, i16, u16, i32, u32, f32, f64, i64, u64, i128, u128, i256, u256, bool, str, bytes }
}
type Cursor = ReturnType<typeof Cursor>
type type_ChannelInclination = {
    black: type_Degree
    cyan: type_Degree
    magenta: type_Degree
    yellow: type_Degree
}
type type_ColorChannel = "cyan" | "magenta" | "yellow" | "black"
type type_Degree = Float<"Degree">
type type_Pixel = Float<"Pixel">
type type_PageNumber = Float<"PageNumber", "i64">
function* enc_SeparationOptions(i: WasmInstance, v: {
    angle: type_ChannelInclination
    data: Uint8Array
    dpi: type_Pixel
    icc: Uint8Array
    lpi: type_Pixel
}): Generator<Uint8Array> {
    yield* enc_ChannelInclination(i, v.angle)
    yield* enc_1drvt9yiommpp(i, v.data)
    yield f64_b(v.dpi)
    yield* enc_1drvt9yiommpp(i, v.icc)
    yield f64_b(v.lpi)
}
function* enc_ChannelInclination(_i: WasmInstance, v: type_ChannelInclination): Generator<Uint8Array> {
    yield f64_b(v.black)
    yield f64_b(v.cyan)
    yield f64_b(v.magenta)
    yield f64_b(v.yellow)
}
function* enc_1drvt9yiommpp(i: WasmInstance, v: Uint8Array): Generator<Uint8Array> {
    const [ptr, len] = write_buf(i, v)
    yield u32_b(ptr)
    yield u32_b(len)
}
function* enc_RasterizeOptions(i: WasmInstance, v: {
    data: Uint8Array
    dpi: type_Pixel
    icc: Uint8Array
}): Generator<Uint8Array> {
    yield* enc_1drvt9yiommpp(i, v.data)
    yield f64_b(v.dpi)
    yield* enc_1drvt9yiommpp(i, v.icc)
}
const dec_ixo9bgh4dhwt = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: {
        channels: Array.from({ length: c.u32() }, () => ({
            bytes: c.bytes(),
            channel: variant_m.get(c.u64())!(c) as type_ColorChannel,
        })),
        height: c.f64() as type_Pixel,
        page: Number(c.i64()) as type_PageNumber,
        width: c.f64() as type_Pixel,
    }, error: undefined }
const dec_23ghdb301sapo = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: {
        bytes: c.bytes(),
        height: c.f64() as type_Pixel,
        page: Number(c.i64()) as type_PageNumber,
        width: c.f64() as type_Pixel,
    }, error: undefined }
const variant_m = new Map<bigint, (c: Cursor) => unknown>([
    [15492634780859405855n, () => "cyan"],
    [15869110479400539346n, () => "magenta"],
    [1635004868251356540n, () => "yellow"],
    [5279583264840665123n, () => "black"],
])
export const Functions = {
    create_separation: (i: WasmInstance, options: SeparationOptions): Result<SeparationResult> => {
        const [retPtr, retLen] = call_with(i, F.create_separation, ...enc_SeparationOptions(i, options))
        const result = dec_ixo9bgh4dhwt(Cursor(i, retPtr))
        call(i, E.free, pa(i, retPtr), pa(i, retLen))
        return result
    },
    rasterize_page: (i: WasmInstance, options: RasterizeOptions): Result<RasterResult> => {
        const [retPtr, retLen] = call_with(i, F.rasterize_page, ...enc_RasterizeOptions(i, options))
        const result = dec_23ghdb301sapo(Cursor(i, retPtr))
        call(i, E.free, pa(i, retPtr), pa(i, retLen))
        return result
    },
}

